import * as e from "react";
import { forwardRef as o } from "react";
const c = o(
  function(t, r) {
    return /* @__PURE__ */ e.createElement(
      "svg",
      {
        fill: "none",
        ref: r,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...t
      },
      /* @__PURE__ */ e.createElement("circle", { cx: 12.5357, cy: 6.03571, fill: "#000", r: 2.03571 }),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M12.5 10V14.5M12.5 14.5L9.88785 16.6768C9.63762 16.8853 9.47055 17.1767 9.417 17.498L9 20M12.5 14.5L15.113 16.6775C15.3627 16.8856 15.5294 17.1763 15.5828 17.4969L16 20",
          stroke: "#000",
          strokeLinecap: "round",
          strokeWidth: 2.03571
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M17 5.49988L17 9.3324C17 9.43373 16.9388 9.52504 16.8451 9.5636L15.0022 10.3218",
          stroke: "#000",
          strokeLinecap: "round",
          strokeWidth: 2.03571
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M7.49998 5.50006L7.49999 9.32335C7.49999 9.42927 7.56673 9.52369 7.66658 9.55903L9.82243 10.322",
          stroke: "#000",
          strokeLinecap: "round",
          strokeWidth: 2.03571
        }
      )
    );
  }
);
export {
  c as BetBuilderBadgeAmericanTd
};
